import React, { useEffect } from "react"
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addLensStock, getLens, checkLensCodeExists, getClinicById, getClinic } from "service/api"
import Select from 'react-select';

import debounce from "lodash.debounce";

import DatatableTables from "./LensStock";
import { jwtDecode } from "jwt-decode"


const defaultValue = {
  lcode: "",
  lname: "",
  lqty: "",
  clinicid: "",
  lname_id: "",
};

const AddLens = () => {
  const [lens, setLens] = useState(defaultValue);
  const [errors, setErrors] = useState({});
  const [lensNames, setLensNames] = useState([]);
  const [allcliniclist, setAllClinicList] = useState([]);
  const [clinicID, setClinicID] = useState(null);
  const [refreshTable, setRefreshTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Lens | Add Lens Stock";

    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      const id = decoded?.clinicID || null;
      setClinicID(id);
      if (id) {
        setLens(prev => ({ ...prev, clinicid: id }));
      }
    }

    fetchLens();
    fetchClinics();
  }, []);

  const fetchLens = async () => {
    try {
      const response = await getLens();
      setLensNames(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching lens list:", error);
    }
  };

  const fetchClinics = async () => {
    try {
      let response;
      if (clinicID) {
        response = await getClinicById(clinicID);
        setAllClinicList([response.data]);
      } else {
        response = await getClinic();
        setAllClinicList(response.data);
      }
    } catch (err) {
      console.error("Error fetching clinic(s)", err);
    }
  };

  const debouncedCheckLcode = debounce(async (lcode) => {
    try {
      const res = await checkLensCodeExists(lcode);
      if (res.data.exists) {
        setErrors(prev => ({ ...prev, lcode: "Lens code already exists" }));
      }
    } catch (err) {
      console.error("Error checking lens code:", err);
    }
  }, 500);

  const onValueChange = (e) => {
    const { name, value } = e.target;
    setLens(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }

    if (name === "lcode" && value.trim()) {
      debouncedCheckLcode(value.trim());
    }
  };

  const validate = () => {
    const formErrors = {};
    if (!lens.lcode.trim()) formErrors.lcode = "Lens code is required";
    // if (!lens.lname.trim()) formErrors.lname = "Lens name is required";
    if (!lens.clinicid.trim()) formErrors.clinicid = "Clinic is required";
    if (!lens.lqty.trim()) formErrors.lqty = "Quantity is required";
    else if (isNaN(lens.lqty) || Number(lens.lqty) < 0) formErrors.lqty = "Quantity must be a valid number";

    if (errors.lcode === "Lens code already exists") formErrors.lcode = errors.lcode;

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleAddLens = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    try {
      await addLensStock(lens);

      toast.success("Lens stock added successfully", {
        position: "top-center",
        autoClose: 1500,
      });

      setLens(defaultValue);
      if (clinicID) {
        setLens(prev => ({ ...prev, clinicid: clinicID }));
      }
      setErrors({});
      setRefreshTable(prev => !prev);
    } catch (error) {
      toast.error("Failed to add lens stock");
      console.error("Add error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title"> Add Lens Stock</h4>
            {/* <Link to="/frames" className="btn btn-danger">Frames</Link> */}
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">
                          Practice Name
                        </Label>
                        <select
                          name="clinicid"
                          className="form-control"
                          onChange={onValueChange}
                          value={lens.clinicid}
                          disabled={!!clinicID}
                        >
                          {!clinicID && <option value="">Choose...</option>}
                          {allcliniclist.map((clinic) => (
                            <option key={clinic._id} value={clinic._id}>
                              {clinic.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {errors.clinicid && (
                        <div className="invalid-feedback">{errors.clinicid}</div>
                      )}
                    </Col>
                    {/* <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Lens Code<span style={{ color: "red" }}>*</span>
                        </Label><Input
                          type="text"
                          name="lcode"
                          value={lens.lcode}
                          className={`form-control ${errors.lcode ? "is-invalid" : ""}`}
                          placeholder="Enter Lens Code"
                          onChange={onValueChange}
                        />

                        {errors.lcode && (
                          <div className="invalid-feedback">{errors.lcode}</div>
                        )}
                      </div>
                    </Col> */}
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label>
                          Lens Code <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Select
                          name="lcode"
                          classNamePrefix="react-select"
                          className={errors.lcode ? "is-invalid" : ""}
                          options={lensNames.map((lens) => ({
                            value: lens._id,            // Send lens ID as value
                            label: lens.lens_code,     // Show lens title
                          }))}
                          value={
                            lens.lname_id
                              ? {
                                value: lens.lname_id,
                                label: lens.lcode,
                              }
                              : null
                          }
                          onChange={(selectedOption) => {
                            setLens((prev) => ({
                              ...prev,
                              lname_id: selectedOption?.value || "",
                              lcode: selectedOption?.label || "", // lens_code string
                            }));
                            if (errors.lcode) {
                              setErrors((prev) => ({ ...prev, lcode: "" }));
                            }
                          }}
                        />
                        {errors.lcode && (
                          <div className="invalid-feedback d-block">{errors.lcode}</div>
                        )}
                      </div>
                    </Col>

                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-quantity">
                          Quantity<span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="number"
                          name="lqty"
                          value={lens.lqty}
                          className={`form-control ${errors.lqty ? "is-invalid" : ""}`}
                          placeholder="Enter Quantity"
                          onChange={onValueChange}
                          min="0"
                        />
                        {errors.lqty && (
                          <div className="invalid-feedback">{errors.lqty}</div>
                        )}
                      </div>
                    </Col>


                  </Row>
                  <div>
                    <Button
                      color="primary"
                      className="w-md mx-2"
                      onClick={handleAddLens}
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </Button>

                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>

          <DatatableTables refresh={refreshTable} />
        </Container>
      </div>
    </React.Fragment>
  );

}

export default AddLens;
